import React, { useEffect, useState } from 'react';
import styles from './prevQuestionLink.module.scss';

const PrevQuestionLink = props => {
  return (
    <div>
      {!props.errorState ? (
        <a
          className={styles.link}
          tabIndex="0"
          href="javascript:void(0)"
          onClick={() => {
            props.setCurrentQuestion(props.prevQuestionIndex);
          }}
          onKeyPress={event => {
            if (event.key === 'Enter') {
              props.setCurrentQuestion(props.prevQuestionIndex);
            }
          }}
        >
          <span className={`${styles.chevron} `}></span>
          Previous question
        </a>
      ) : null}
    </div>
  );
};

export default PrevQuestionLink;
